import React from 'react';
import { returnToTools, toolsUrl } from './sso';

// Mirrored in each independently built app, like ThemeToggle.
export default function AppExit({ account, app, onSignOut, disabled = false }) {
  if (!account) return null;
  const otherApps = account.enabled !== false && Object.entries(account.apps || {})
    .some(([id, enabled]) => id !== app && enabled === true);
  const icon = <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {otherApps ? <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>
      : <path d="M10 4H4v16h6M9 12h12m-5-5 5 5-5 5"/>}
  </svg>;
  return otherApps
    ? <a className="app-exit" href={toolsUrl()} onClick={returnToTools} aria-label="All tools" title="All tools">{icon}<span>All tools</span></a>
    : <button type="button" className="app-exit" onClick={onSignOut} disabled={disabled} aria-label="Sign out" title="Sign out">{icon}<span>Sign out</span></button>;
}
